import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { GateProvider } from "@/context/GateContext";
import PublicLayout from "@/components/PublicLayout";
import PortalShell from "@/components/PortalShell";
import Home from "@/pages/public/Home";
import Risk from "@/pages/public/Risk";
import Markets from "@/pages/public/Markets";
import Apply from "@/pages/public/Apply";
import Contact from "@/pages/public/Contact";
import About from "@/pages/_archive/About";
import Privacy from "@/pages/public/Privacy";
import Terms from "@/pages/public/Terms";
import Login from "@/pages/public/Login";
import AuthCallback from "@/pages/public/AuthCallback";
import MarketsGuide from "@/pages/public/MarketsGuide";
import Leverage from "@/pages/public/Leverage";
import Fellowship from "@/pages/public/Fellowship";
import ClientPortal from "@/pages/portal/ClientPortal";
import AdminPortal from "@/pages/portal/AdminPortal";
import SuperPortal from "@/pages/portal/SuperPortal";

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <GateProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/risk" element={<Risk />} />
              <Route path="/markets" element={<Markets />} />
              <Route path="/the-markets" element={<MarketsGuide />} />
              <Route path="/leverage" element={<Leverage />} />
              <Route path="/fellowship" element={<Fellowship />} />
              <Route path="/apply" element={<Apply />} />
              <Route path="/contact" element={<Contact />} />
              {/* Firm/About page archived — keep route commented for easy re-enable
              <Route path="/about" element={<About />} /> */}
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/login" element={<Login />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
            </Route>

            <Route path="/portal/*" element={
              <Protected roles={["client"]}>
                <PortalShell variant="client"><ClientPortal /></PortalShell>
              </Protected>
            } />
            <Route path="/admin/*" element={
              <Protected roles={["admin", "super_admin"]}>
                <PortalShell variant="admin"><AdminPortal /></PortalShell>
              </Protected>
            } />
            <Route path="/super/*" element={
              <Protected roles={["super_admin"]}>
                <PortalShell variant="super"><SuperPortal /></PortalShell>
              </Protected>
            } />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </GateProvider>
    </AuthProvider>
  );
}
